module.exports = __webpack_public_path__ + "img/paid.af196113.svg";